/* eslint-disable @typescript-eslint/no-explicit-any */
import { TasklistService } from '@/api/tasklist';
import { Button } from 'alurkerja-ui';
import { ArrowLeft, UserRound } from 'lucide-react';
import { useContext } from 'react';
import ModalDelegateTask from './ModalDelegateTask';
import { MyTaskContextNew } from '@/pages/task/MyTask';
import { TasklistMyTaskContext } from '@/pages/tasklist/TasklistMyTask';
import { GroupTaskContext } from '@/pages/group-task/GroupTaskPage';
import { MyRequestContext } from '@/pages/request/MyRequest';
import moment from 'moment';

export default function HeaderTask({
  taskDetail,
  refetch,
  allowedToEditForm,
  isMyRequest = false,
}: {
  taskDetail: any;
  refetch: () => void;
  allowedToEditForm: boolean;
  isMyRequest?: boolean;
}) {
  const { refetchMyTask, resetSelectedTask } = useContext(MyTaskContextNew);
  const { refetchTasklistMyTask, resetSelectedTask: resetSelectedTaskTasklist } = useContext(TasklistMyTaskContext);
  const { refetchMyTask: refetchMyGroupTask, resetSelectedTask: resetSelectedGroupTaskList } =
    useContext(GroupTaskContext);
  const { resetSelectedTask: resetSelectedTaskRequest } = useContext(MyRequestContext);

  const { mutate: mutateClaimTask } = TasklistService.useClaimTask({
    onSuccess() {
      refetch();
      refetchMyTask?.();
      refetchTasklistMyTask?.();
      resetSelectedGroupTaskList?.();
      refetchMyGroupTask?.();
    },
  });

  const { mutate: mutateUnclaimTask } = TasklistService.useUnclaimTask({
    onSuccess() {
      refetch();
      refetchMyTask?.();
      refetchTasklistMyTask?.();
    },
  });

  const handleClaimTask = () => {
    const processDefinitionKey = taskDetail?.process_definition_id;
    if (processDefinitionKey) {
      mutateClaimTask({ taskId: taskDetail!.id, processDefinitionKey });
    } else {
      // handle the case where processDefinitionKey is undefined
      console.error('processDefinitionKey is undefined');
    }
  };

  const handleUnclaimTask = () => {
    const processDefinitionKey = taskDetail?.process_definition_id;
    if (processDefinitionKey) {
      mutateUnclaimTask({ taskId: taskDetail!.id, processDefinitionKey });
    } else {
      // handle the case where processDefinitionKey is undefined
      console.error('processDefinitionKey is undefined');
    }
  };
  return (
    <div className="group-header flex flex-col space-y-4 border-b py-1 sm:py-4">
      <div className="w-full flex justify-start items-center gap-2">
        <div className="block sm:hidden">
          <Button
            className="bg-white hover:bg-white pl-2 pr-2 pt-2 pb-2"
            size="small"
            data-testid="back-button"
            onClick={() => {
              resetSelectedTaskTasklist?.();
              resetSelectedTask?.();
              resetSelectedTaskRequest?.();
            }}
            icon={<ArrowLeft color="black" size={20} className="leading-3" />}
          ></Button>
        </div>
        <div className="flex flex-row w-full">
          <span className="w-full text-md sm:text-xl font-semibold text-left">{taskDetail?.name}</span>
          <span className="w-full text-sm sm:text-md text-right pt-2 sm:px-2">
            Created on {moment(taskDetail?.created_date, 'YYYY-MM-DDTHH:mm').format('DD MMM YYYY HH:mm:ss')}
          </span>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
        <span className="text-sm lg:text-md">{taskDetail?.variables?.processName}</span>
        <div className="flex items-start mt-2 sm:mt-0 sm:items-center">
          <UserRound size={20} className="fill-black-alurkerja-2 stroke-transparent hidden sm:block" />
          {taskDetail?.assignee === '-' && !isMyRequest && (
            <Button className="rounded-full" size="small" variant="text" onClick={handleClaimTask} data-testid="claim-task">
              Claim
            </Button>
          )}
          {taskDetail?.assignee !== '-' && (
            <div className="flex flex-col sm:flex-row items-start sm:items-center flex-wrap justify-start sm:justify-end">
              <span className="ml-0 sm:ml-2 text-sm lg:text-md truncate">{taskDetail?.assignee}</span>

              {allowedToEditForm && (
                <div className="flex gap-2 sm:gap-0">
                  <ModalDelegateTask
                    processKey={taskDetail.process_definition_id}
                    taskId={taskDetail.id}
                    refetch={refetch}
                  />
                  <Button
                    className="rounded-full text-red-500 py-0 pl-0 pr-0 sm:px-2"
                    size="small"
                    variant="text"
                    onClick={handleUnclaimTask}
                    data-testid="unclaim-task"
                  >
                    Unclaim
                  </Button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
